import { lazy, Suspense, useEffect, useState } from 'react';
import Index from './jsx/index';
import { connect, useDispatch } from 'react-redux';
import { Navigate, Route, Routes, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
import { RTL_LANGUAGES } from './i18n';

import './other/swiper/css/swiper-bundle.min.css';
// import "./other/bootstrap-select/dist/css/bootstrap-select.min.css";
import "./css/style.css";
// Après style.css : celui-ci importe Themify Icons, qui utilise aussi le
// préfixe "ti-" (.ti-bell, .ti-eye...). Chargé avant, Themify écrasait le
// `content` de ces icônes Tabler -> carré vide (glyphe absent de la police).
import "@tabler/icons-webfont/dist/tabler-icons.min.css";
import "./css/dashboard-theme.css";
import "./css/tailwind.css";

import { loginConfirmedAction, logoutAction } from './store/actions/AuthActions';

const SignUp = lazy(() => import('./jsx/pages/Registration'));

const Login = lazy(() =>
  new Promise(resolve => {
    setTimeout(() => resolve(import('./jsx/pages/Login')), 500);
  })
);

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    );
  }

  return ComponentWithRouterProp;
}

function App(props) {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  // 🔥 IMPORTANT: éviter le flash login/dashboard
  const [authReady, setAuthReady] = useState(false);

  useEffect(() => {
    const session = checkAutoLogin();

    if (session) {
      dispatch(loginConfirmedAction(session));
    } else {
      dispatch(logoutAction());
    }

    setAuthReady(true);
  }, [dispatch]);

  useEffect(() => {
    const applyDirection = (lng) => {
      document.documentElement.lang = lng;
      const dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr';
      document.documentElement.dir = dir;
      // Le CSS du template (style.css) lit [direction=rtl] sur le même
      // élément que data-sidebar-style/data-theme-version, posés sur <body>
      // par ThemeContext — l'attribut doit donc être sur <body>, pas <html>.
      document.body.setAttribute('direction', dir);
    };

    applyDirection(i18n.language);
    i18n.on('languageChanged', applyDirection);

    return () => i18n.off('languageChanged', applyDirection);
  }, [i18n]);

  console.log("isAuthenticated =", props.isAuthenticated);

  // 🔥 BLOQUE L’APP TANT QUE AUTH PAS PRÊT
  if (!authReady) {
    return (
      <div className="vh-100 d-flex justify-content-center align-items-center">
        Loading...
      </div>
    );
  }

  // =========================
  // ROUTES NON CONNECTÉ
  // =========================
  const routeblog = (
    <Routes>
      <Route
        path="/"
        element={<Navigate to="/login" replace />}
      />

      <Route
        path="/login"
        element={
          props.isAuthenticated
            ? <Navigate to="/dashboard" replace />
            : <Login />
        }
      />

      <Route
        path="/page-register"
        element={
          props.isAuthenticated
            ? <Navigate to="/dashboard" replace />
            : <SignUp />
        }
      />

      {/* fallback */}
      <Route
        path="*"
        element={<Navigate to="/login" replace />}
      />
    </Routes>
  );

  // =========================
  // APP CONNECTÉ
  // =========================
  return props.isAuthenticated ? (
    <Suspense fallback={
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    }>
      <Index />
    </Suspense>
  ) : (
    <div className="vh-100">
      <Suspense fallback={
        <div id="preloader">
          <div className="sk-three-bounce">
            <div className="sk-child sk-bounce1"></div>
            <div className="sk-child sk-bounce2"></div>
            <div className="sk-child sk-bounce3"></div>
          </div>
        </div>
      }>
        {routeblog}
      </Suspense>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(App));